export default __webpack_public_path__ + "static/stitched-d951ce825dc41b778382db67d93d1989.jpg";